import { HttpInstance } from "lib/HttpLib";

// ==================== GET ====================
// [GET] 지점 접근 권한 가져오기
export async function getBranchAccessPermissions(authCode) {
  return await HttpInstance.get(
    process.env.REACT_APP_AUTH_SERVER + "/permissions/access-scopes/branches",
    {
      params: {
        auth_code: authCode,
      },
    },
  );
}
